module.exports = {
	"data": {
		"postBySlug": {
			"html": "<h2 id=\"export-the-caaml-application-schema-configuration\"><a href=\"#export-the-caaml-application-schema-configuration\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>Export the CAAML application schema configuration</h2>\n<p>At the end of the mapping session we should have completed all the mapping properties for our <strong>Region</strong> target type and the Hale window should look like:</p>\n<p>\n  <a\n    class=\"gatsby-resp-image-link\"\n    href=\"undefined\"\n    style=\"display: block\"\n    target=\"_blank\"\n    rel=\"noopener\"\n  >\n  \n  <span\n    class=\"gatsby-resp-image-wrapper\"\n    style=\"position: relative; z-index: -1; display: block; \"\n  >\n    <span\n      class=\"gatsby-resp-image-background-image\"\n      style=\"padding-bottom: 34.53125%;position: relative; width: 100%; bottom: 0; left: 0; background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAYAAAAIy204AAAACXBIWXMAAAsSAAALEgHS3X78AAABoElEQVQoz3WRzXPSUBRH8/9vXLhw56ij1qkjjjq0tVUGqI2ggNAmIWH4KCQhJIEkJSUUknB8E1248c6czX1zz/vduZK/XBHHMet1jOuvsGwHx3FYLpeity4o+pbNbDZlai7w/SVZlhVviZibmC5hGJFsEiTPD3DmcwIhSPd78jQlE0ysIS39Ct3uYlhddOsXk4WOF/mMPIPdbsdkHhBECZvthok3Yi/mJVntc1ypcVT9Rrndo9zp0RiM0E2d88YnWrc/0OyfghZjV8O7WzIKDFLxqTENWN1tSXYJfVctUks1Reb5xSte1t9w3CwVVNQ66lTlRP6IPKhzbTVR7CZDV8EJXcahUQwPZhFR/MB6G6N5CvtUJKyp5zz78kiIHvO+86SgbnwohKci4aVWoWc2UIR0uFCYC+Eo6P8Rmn+FyRrNvWGXPiBdaZe8rT3ltHvE1/67gs5tnZvpNWW5RFU5E2tXaQv6dodVHOHEJnmeY3v33G/3bMXK03BCmqVIczcUR1mIg2T8W+3xd0ryC056r/msHHEmaAwvOBwO/K/yLOc33Q75pXGSAqYAAAAASUVORK5CYII='); background-size: cover; display: block;\"\n    >\n      <img\n        class=\"gatsby-resp-image-image\"\n        style=\"width: 100%; margin: 0; vertical-align: middle; position: absolute; top: 0; left: 0; box-shadow: inset 0px 0px 0px 400px white;\"\n        alt=\"mapped region hale\"\n        title=\"\"\n        src=\"/static/24b5cb80e84ec5cb3ff09b06ee12b947-44d6a.png\"\n        srcset=\"/static/24b5cb80e84ec5cb3ff09b06ee12b947-f4799.png 173w,\n/static/24b5cb80e84ec5cb3ff09b06ee12b947-b3b1d.png 345w,\n/static/24b5cb80e84ec5cb3ff09b06ee12b947-44d6a.png 690w,\n/static/24b5cb80e84ec5cb3ff09b06ee12b947-bc0f7.png 1035w,\n/static/24b5cb80e84ec5cb3ff09b06ee12b947-b50e5.png 1380w,\n/static/24b5cb80e84ec5cb3ff09b06ee12b947-0ed32.png 2070w,\n/static/24b5cb80e84ec5cb3ff09b06ee12b947-55f2e.png 2560w\"\n        sizes=\"(max-width: 690px) 100vw, 690px\"\n      />\n    </span>\n  </span>\n  \n  </a>\n    </p>\n<p>Assuming we have our instance of GeoAvalanche running locally at <code>http://localhost:8080/geoavalanche</code> let's see how simple is to get CAAML features published from that server:</p>\n<p>\n  <a\n    class=\"gatsby-resp-image-link\"\n    href=\"undefined\"\n    style=\"display: block\"\n    target=\"_blank\"\n    rel=\"noopener\"\n  >\n  \n  <span\n    class=\"gatsby-resp-image-wrapper\"\n    style=\"position: relative; z-index: -1; display: block; \"\n  >\n    <span\n      class=\"gatsby-resp-image-background-image\"\n      style=\"padding-bottom: 62.5%;position: relative; width: 100%; bottom: 0; left: 0; background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsSAAALEgHS3X78AAADEUlEQVQ4y11TbW/aZhT1H98/2JdIW1Opy9ZNNJSFdglSCtOipkDLkqZpAwkvxsbGYIMNxvgFjI3te3bxh2naIx3Zfu5z7z33PMdCo3KBq8qfqH9U6e76Ez00b0ntiGRKGqROD5W3Z6idn6N2+Q71egON6ytc8nu1ynhXxYf317j66wrNRhM3rRsI8kiBqo4xNUySJYkm2oRc16U0SeGuXRpzTJYVDEUR/X4PD+0eRHEI0zRhGAZmuoH7dh+GPoNt2xCW9gprx4HnOuSsljnSNCYgxS7ySTS+oqt9RltpQZy0sVgvMbFHiOMYhrWC5wXYbDcwVnq+J9z1VVzU73HZ0qn+1aWPjzH93Uup1U1Qfwio9WRRvW1T89FDd7yEs1lj6qlIeAJRc2C7IaJ9BGUlIUszCJ/6tzhr/o62LJOkLUnRecyZT+ZqD30R0kA2aDCak+2lNOORZmsTsjNAkqYYTlys/Qhe6KNrPSJOmGHt4RxHle8w0L6RKPVoIHZpOOyxdiMKtwFp6pjGikpJHFO4C2jmWJBWfaRpgv7YyQv6XLAza2Of7Hnk4RfUbv7ASBNJURWSZIkkvpzhcEiGpVP1tkw1RuOpSp3xDfnhBna4QJZlsJwQYZQg3seY+/O8iWAtPZgziy/Fo+12S0GwYQTkeR7Z6wV9lj/gi1LHnXyN3vQeaZYiowz/X4QsbyKY5hKz2Ry73S6/pf1+z4InSPiZsU7/XWmccjzmWMLnwxyHHCaCiPOjaAdBZR+a1gKu64GZcTCE7/vYbDZw2BLrIMQ2jPL9gM9sNgHHA8znU/avmnvP4vyDLw/2EzRNw0hRMZlMsXLWDAcHs0/ZsG1pAlFnn273rFPyL6Joj6Wtg7WGx80zloElypkKB6d/e+ig3XmCNtExNy3+G9p46vbRHwwwHmtwXB8us/IYa8+Hw40Xcw26rsN33Zx9GPIEXFwoFIoolc5QLlfwuvQGr/n7zatjlIpFnL76FafFExyfvESxWMJFuYCTwgs8O/oeP//2I45/OMLbn17gl0IZpdMCXj5/hn8AOAis4eCFXLAAAAAASUVORK5CYII='); background-size: cover; display: block;\"\n    >\n      <img\n        class=\"gatsby-resp-image-image\"\n        style=\"width: 100%; margin: 0; vertical-align: middle; position: absolute; top: 0; left: 0; box-shadow: inset 0px 0px 0px 400px white;\"\n        alt=\"export region hale\"\n        title=\"\"\n        src=\"/static/c607bcd41f07abf43628bcca37b6755f-44d6a.png\"\n        srcset=\"/static/c607bcd41f07abf43628bcca37b6755f-f4799.png 173w,\n/static/c607bcd41f07abf43628bcca37b6755f-b3b1d.png 345w,\n/static/c607bcd41f07abf43628bcca37b6755f-44d6a.png 690w,\n/static/c607bcd41f07abf43628bcca37b6755f-bc0f7.png 1035w,\n/static/c607bcd41f07abf43628bcca37b6755f-b50e5.png 1380w,\n/static/c607bcd41f07abf43628bcca37b6755f-0ed32.png 2070w,\n/static/c607bcd41f07abf43628bcca37b6755f-55f2e.png 2560w\"\n        sizes=\"(max-width: 690px) 100vw, 690px\"\n      />\n    </span>\n  </span>\n  \n  </a>\n    </p>\n<p>From the <code>File</code> menu select <code>Export</code> and then click on <code>Alignment</code>:</p>\n<p>\n  <a\n    class=\"gatsby-resp-image-link\"\n    href=\"undefined\"\n    style=\"display: block\"\n    target=\"_blank\"\n    rel=\"noopener\"\n  >\n  \n  <span\n    class=\"gatsby-resp-image-wrapper\"\n    style=\"position: relative; z-index: -1; display: block; \"\n  >\n    <span\n      class=\"gatsby-resp-image-background-image\"\n      style=\"padding-bottom: 78.81679389312978%;position: relative; width: 100%; bottom: 0; left: 0; background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAQCAYAAAAWGF8bAAAACXBIWXMAAAsSAAALEgHS3X78AAAB5UlEQVQ4y62UXY/SQBSG+/9/gm70ykujRC/M7kaJqVhht6V0+4nQ0u8WprSFKrXA63R0TVbZLKiTPHknp5M358w5He6m+w5XYh9X8icoivIHPM9DEASmvV4Pw+Hw4LmW0UgBN3Mc2I4N0zQRRRH2+z12u90v3W63d2hjv7Pf7+BGS2RlDW5VlgiCAJ7nIU1ThGGIxYIw8zwvcMyyZguIRoSPckgNixyrIvvJEmVOmBZLQvcZqlVOKfBlfT/LjNBkFnD9FNyFMMHZ6zHOXplMH3dUPOroeM7P8aJH0BEInnVTPDmP7+XpxQ99+SEGNxjqOH8v4U33Gpf8CG97Cq5VF7pNoHxOoE5SaM4S03jzADVm8QrcZGzBNDRoqgJDV2GZOpI4ROC58GY2LT1DU3896i6bbxtwY8uCLI9wQ9uu6wZ0TWcNKWmziqJAXdesk8eszYYaqqoKmc7WoN+HJEnQqKFPu75eVzh1MUODZmUaBhtYURQxnU7Z+BBC0DTNSVRVBc6n8+fYDjzXo2Y24ihm5ZZFSecwP4mMZOCSOMEtaZIybU3/ljuG/wPuX7I5mGEYhHgI3w/pvx4wvY0FfnDw7MGS27uM6CMRhRGdyQTSOMJAcyFP5+x7G3foKzWfz9nZ1qiNtfvvsBajEZPxfKwAAAAASUVORK5CYII='); background-size: cover; display: block;\"\n    >\n      <img\n        class=\"gatsby-resp-image-image\"\n        style=\"width: 100%; margin: 0; vertical-align: middle; position: absolute; top: 0; left: 0; box-shadow: inset 0px 0px 0px 400px white;\"\n        alt=\"export format hale\"\n        title=\"\"\n        src=\"/static/dfe45fc6313a0f18e95db4bc2345112c-44d6a.png\"\n        srcset=\"/static/dfe45fc6313a0f18e95db4bc2345112c-f4799.png 173w,\n/static/dfe45fc6313a0f18e95db4bc2345112c-b3b1d.png 345w,\n/static/dfe45fc6313a0f18e95db4bc2345112c-44d6a.png 690w,\n/static/dfe45fc6313a0f18e95db4bc2345112c-bc0f7.png 1035w,\n/static/dfe45fc6313a0f18e95db4bc2345112c-526b7.png 1048w\"\n        sizes=\"(max-width: 690px) 100vw, 690px\"\n      />\n    </span>\n  </span>\n  \n  </a>\n    </p>\n<p>Select <code>App-Schema Configuration [Direct Upload]</code> then click <code>Next</code></p>\n<p>\n  <a\n    class=\"gatsby-resp-image-link\"\n    href=\"undefined\"\n    style=\"display: block\"\n    target=\"_blank\"\n    rel=\"noopener\"\n  >\n  \n  <span\n    class=\"gatsby-resp-image-wrapper\"\n    style=\"position: relative; z-index: -1; display: block; \"\n  >\n    <span\n      class=\"gatsby-resp-image-background-image\"\n      style=\"padding-bottom: 78.77629063097514%;position: relative; width: 100%; bottom: 0; left: 0; background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAQCAYAAAAWGF8bAAAACXBIWXMAAAsSAAALEgHS3X78AAABYElEQVQ4y+2UW0/CMBiG+/9/kBfeGE1IyBDRsXUDxg5t18MGqPHCBIHXruAEhBgTL7ywyZPv0K/vTd+WhDfX6N/3MBj2EATBFzqdDjzPc7Hb7cL3/ZNzDUMLybMMmYVSiiiikFJhvV63rFarNn7kxyyXb8jKBfT8FeTgoGWz2eCnK+Fz3EUKt6EBqaoKxhjUdQ1TG3BVQ+iZi0zWmOTC5dz2irKCnj2jfnw5QFRPyOUCcTEHmYzHiGiEdJoiLxjCcYYHOkHfj+BHUwzj1PZy148SZoUXkFZ0H7WLWTkDGY9GTpCGFEUjSGPHMKBIphkYEyh2MF6ilBpSmZNwIUEEF2hgVkyWEpwxW3OHkhJG6RbtUOexF0qMNvhN/gX/oqBu7XAeoz/5bpYo651TNJ7cosC5dKZujLu/dzyrzvmwMhXS1D7FvLAiGpdejotOjKuBdPvMmj+ZJHD/gK23D0G4/B317qEXO1/0ZAAAAABJRU5ErkJggg=='); background-size: cover; display: block;\"\n    >\n      <img\n        class=\"gatsby-resp-image-image\"\n        style=\"width: 100%; margin: 0; vertical-align: middle; position: absolute; top: 0; left: 0; box-shadow: inset 0px 0px 0px 400px white;\"\n        alt=\"export destination hale\"\n        title=\"\"\n        src=\"/static/c6f1c08b0f2a7fc1434ad79b52cb8cd0-44d6a.png\"\n        srcset=\"/static/c6f1c08b0f2a7fc1434ad79b52cb8cd0-f4799.png 173w,\n/static/c6f1c08b0f2a7fc1434ad79b52cb8cd0-b3b1d.png 345w,\n/static/c6f1c08b0f2a7fc1434ad79b52cb8cd0-44d6a.png 690w,\n/static/c6f1c08b0f2a7fc1434ad79b52cb8cd0-bc0f7.png 1035w,\n/static/c6f1c08b0f2a7fc1434ad79b52cb8cd0-033d7.png 1046w\"\n        sizes=\"(max-width: 690px) 100vw, 690px\"\n      />\n    </span>\n  </span>\n  \n  </a>\n    </p>\n<p>Fill the <code>Target URL</code> with the base url for your server <code>http://localhost:8080/geoavalanche</code> and then click <code>Next</code></p>\n<p>\n  <a\n    class=\"gatsby-resp-image-link\"\n    href=\"undefined\"\n    style=\"display: block\"\n    target=\"_blank\"\n    rel=\"noopener\"\n  >\n  \n  <span\n    class=\"gatsby-resp-image-wrapper\"\n    style=\"position: relative; z-index: -1; display: block; \"\n  >\n    <span\n      class=\"gatsby-resp-image-background-image\"\n      style=\"padding-bottom: 78.70722433460075%;position: relative; width: 100%; bottom: 0; left: 0; background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAQCAYAAAAWGF8bAAAACXBIWXMAAAsSAAALEgHS3X78AAABaklEQVQ4y+2U32+CMBDH+f//qe0BgmagDJQ5AwgUSgsIGXtbAt/1aozOmele9jSSD/ej17trcq0RPD7AXThwnm0EQfANy7Jg27aWhOd5V+MI3w9g5FmGMAyRpimiKMJ2u4UQAuM4Ypymg7xgUv7pbG2aRuRVj/79AwbnJUzThOu6qoKvZaaK1HWtkKiqClJKXYRzrv1kl2WhC9IXsT28VwFrWcBomkYHkWzbVstu36HvVMWuQ3eO9p/04W3AMAxo2h5c7LFjrTpymmEVrLB52WC9WqNghapeoixOkO8ajDHNQSdfCWOX7GDaDmb2DPPZHK7jYqGO/ez5WC6WWk/iBBR3i0w1Z7CcIU5SxFGsN5IkKOBoU5e85HdhUHAt6x+RQt6NTvibDf8J/yihqMRN5B0xhJHn+dV5Ot4S0hkjSrDi6/rVOaTfZdtN3aAoDtdLKHseclhegqeNUI+F1J2kuxRt0+o51cl4pfVPLbuZs4Nm7vQAAAAASUVORK5CYII='); background-size: cover; display: block;\"\n    >\n      <img\n        class=\"gatsby-resp-image-image\"\n        style=\"width: 100%; margin: 0; vertical-align: middle; position: absolute; top: 0; left: 0; box-shadow: inset 0px 0px 0px 400px white;\"\n        alt=\"export option hale\"\n        title=\"\"\n        src=\"/static/b0003e3ac64b23a7cf42762b651cfdba-44d6a.png\"\n        srcset=\"/static/b0003e3ac64b23a7cf42762b651cfdba-f4799.png 173w,\n/static/b0003e3ac64b23a7cf42762b651cfdba-b3b1d.png 345w,\n/static/b0003e3ac64b23a7cf42762b651cfdba-44d6a.png 690w,\n/static/b0003e3ac64b23a7cf42762b651cfdba-bc0f7.png 1035w,\n/static/b0003e3ac64b23a7cf42762b651cfdba-c028b.png 1052w\"\n        sizes=\"(max-width: 690px) 100vw, 690px\"\n      />\n    </span>\n  </span>\n  \n  </a>\n    </p>\n<p>Tick the option to include your custom target schema until it's not published online and then click <code>Next</code></p>\n<p>\n  <a\n    class=\"gatsby-resp-image-link\"\n    href=\"undefined\"\n    style=\"display: block\"\n    target=\"_blank\"\n    rel=\"noopener\"\n  >\n  \n  <span\n    class=\"gatsby-resp-image-wrapper\"\n    style=\"position: relative; z-index: -1; display: block; \"\n  >\n    <span\n      class=\"gatsby-resp-image-background-image\"\n      style=\"padding-bottom: 78.74762808349148%;position: relative; width: 100%; bottom: 0; left: 0; background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAQCAYAAAAWGF8bAAAACXBIWXMAAAsSAAALEgHS3X78AAAB7UlEQVQ4y52UaW/aQBCG/f9/VBupBVFCIJijIhAI+D7WBzYGG8ybmU1MoNhSlQ+P3t25dnZ8KOOHn3ga9NBTOxiNRne0Wi10Oh2p7XYbw+GwNq5C0TYbqBS0IX2Zv2A2m8FxXJzP5/+iLEucTiXWVggRH6DYto3unw76/T56j4+yg8FggPFoTLYn9GnNNlVVoVIHr4sFOMd1XTrYge/7eNUDPM9stJ8NKJ7rSSMHuNQZq+d5F2UfawXvAxEgiiIIIeTa8wOYto+V5kGZTiaYENluJ+HAv9MpTMNAt9uVLKir5XKJt9UKtmXJWfEtkiTFjnIkaYowDKHougFfhNjnhSTN9hBBiHibwKbubcdDGMUI4y2iOEGSZnB9AdcT2B8+cg6fcI4iqFh+PJPhJMkoKD+WFHxEcTpLeF9xKEoZV3BOcbrkMXGyoxnS/a+N2b640TqafPE2heJzQT7pE+7wWuto8m25Q5+eUk6bCp7JtdbR5JMFBRUsaDYVh/x4o3U0+ZJUzlBcnjCT7fMbraPJJ2doWQ6CMP4iiG61jgafT80phq7Ty2p/E+vORj8HDZZp3WEa5ge01nQTmmZA180vO/FvLK+pQwOO7dzA3/RmvcH6bQ2LTv011PGjO8fvMSWbtkxezBfg/wDH8y2rOu+NbLcQifw2PwAAAABJRU5ErkJggg=='); background-size: cover; display: block;\"\n    >\n      <img\n        class=\"gatsby-resp-image-image\"\n        style=\"width: 100%; margin: 0; vertical-align: middle; position: absolute; top: 0; left: 0; box-shadow: inset 0px 0px 0px 400px white;\"\n        alt=\"export workspaces hale\"\n        title=\"\"\n        src=\"/static/4ab2dc65c2d2bca5f66c09663d90cbf8-44d6a.png\"\n        srcset=\"/static/4ab2dc65c2d2bca5f66c09663d90cbf8-f4799.png 173w,\n/static/4ab2dc65c2d2bca5f66c09663d90cbf8-b3b1d.png 345w,\n/static/4ab2dc65c2d2bca5f66c09663d90cbf8-44d6a.png 690w,\n/static/4ab2dc65c2d2bca5f66c09663d90cbf8-bc0f7.png 1035w,\n/static/4ab2dc65c2d2bca5f66c09663d90cbf8-3a75d.png 1054w\"\n        sizes=\"(max-width: 690px) 100vw, 690px\"\n      />\n    </span>\n  </span>\n  \n  </a>\n    </p>\n<p>Double check your workspace configuration and then click <code>Next</code></p>\n<p>\n  <a\n    class=\"gatsby-resp-image-link\"\n    href=\"undefined\"\n    style=\"display: block\"\n    target=\"_blank\"\n    rel=\"noopener\"\n  >\n  \n  <span\n    class=\"gatsby-resp-image-wrapper\"\n    style=\"position: relative; z-index: -1; display: block; \"\n  >\n    <span\n      class=\"gatsby-resp-image-background-image\"\n      style=\"padding-bottom: 79.04761904761905%;position: relative; width: 100%; bottom: 0; left: 0; background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAQCAYAAAAWGF8bAAAACXBIWXMAAAsSAAALEgHS3X78AAABs0lEQVQ4y62UCW/iMBCF8///VKsVSlOgbQ4ggZyOcwccCKlQJejr2LvddlW6CKmRPtny8TRvZmJtdnuD6eMYU+sejuN8YTQawTAMNeq6DtM0z56T2LYDjacMQRBg6S3h+z7m8znSNIXnefBcFy5xOBxwPB4Vp9PpC6+vJ6RlB9G/QKvEgLIskWUZGAnxlCvBoijAOVd7l74VW+PRK3FnFdBEt0UnOnTdB5vNBkIIiI1Q4263w5bOfUfdrJEVLSLWQGvqBpI4iuEuXLIfIo5jhGGIKIpUGhhjSvQ7+r6nsadABFkuK0jShMG4Myi5M6yWK5U7xlK0basi3u/3F5HutLqqIcmzHOP7MRzbxowqliQJ2enwPAwYJHThEtt3QWk5pWimkyksy8HkwYQ1c9HtBogrqFoSZGTV9wPK3wKT8QQmCepPHsxFgKzpriIu1tASKsCScuYTshdlURYBp6o1V8Pz+sPyZ+qqwu/cVlfztyg/xc8Lvvfh/6g/cemsVuQFziH7UiLnnOd/+Hf/3L2zltumRcYzejByehxq6DbHr4cQxrxU+2VRqsaXf5EsohSSa3L+BmZtoCfEg8LBAAAAAElFTkSuQmCC'); background-size: cover; display: block;\"\n    >\n      <img\n        class=\"gatsby-resp-image-image\"\n        style=\"width: 100%; margin: 0; vertical-align: middle; position: absolute; top: 0; left: 0; box-shadow: inset 0px 0px 0px 400px white;\"\n        alt=\"export datastore configuration hale\"\n        title=\"\"\n        src=\"/static/f87457377530de7bdf80c67561630cad-44d6a.png\"\n        srcset=\"/static/f87457377530de7bdf80c67561630cad-f4799.png 173w,\n/static/f87457377530de7bdf80c67561630cad-b3b1d.png 345w,\n/static/f87457377530de7bdf80c67561630cad-44d6a.png 690w,\n/static/f87457377530de7bdf80c67561630cad-bc0f7.png 1035w,\n/static/f87457377530de7bdf80c67561630cad-200fd.png 1050w\"\n        sizes=\"(max-width: 690px) 100vw, 690px\"\n      />\n    </span>\n  </span>\n  \n  </a>\n    </p>\n<p>Fill the values for the <strong>PostGIS</strong> datastore connection parameters and then click <code>Next</code></p>\n<p>\n  <a\n    class=\"gatsby-resp-image-link\"\n    href=\"undefined\"\n    style=\"display: block\"\n    target=\"_blank\"\n    rel=\"noopener\"\n  >\n  \n  <span\n    class=\"gatsby-resp-image-wrapper\"\n    style=\"position: relative; z-index: -1; display: block; \"\n  >\n    <span\n      class=\"gatsby-resp-image-background-image\"\n      style=\"padding-bottom: 79.19847328244275%;position: relative; width: 100%; bottom: 0; left: 0; background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAQCAYAAAAWGF8bAAAACXBIWXMAAAsSAAALEgHS3X78AAABrklEQVQ4y+WUW4+bMBSE+f9/aldVCUmUtlyTcAkEsAGbW7RJXyqFqQ9h0YqN1Id9LNKnmWOs4RhsNOf1BT9+7rCzDDiO8wld12EYxqiEaZpP5xG27UDL0hT7/R5BECBJzrjf7xiGYYbqJct7w3BHVvbor3+g9V0Hxhg456gqASklpBDKVyjLEkLVQtVEURTjuBDVqNfbDXRFeQvTr6D/YtDapkHfq3QVTLRNCxprJtoPNHU9j5F2av7lclFNNOBFjTgV0ApeID2niJMUzjFCKTvI7m2knvRZ/cxz2UMLgxCWacE7hDC9EMdTDiZ6yMtvyH5i4UV3Q9VdlT5492mlAqm7s/oYWcZwCvZ4/fYd+mqNlbHFerPDZrtT9QbGejt71zvCcQ84+iF8P1IajT7LS2hcLVkK9eLVBynzBJ7rwXVcOJY9qqewlXfUlnh4C1EYgVYWn2IkE+RLlaVxxsewBxK1rP8JNfAMylgEfp3/NbAqqy8hJshrWZaBTssSehAx15x/uk/KWIE85yPkx6O3bJu2Bv0wWM7m7UAB7546ocPQ1A38RGBlnbGyUxxigb+nFZsEogATDgAAAABJRU5ErkJggg=='); background-size: cover; display: block;\"\n    >\n      <img\n        class=\"gatsby-resp-image-image\"\n        style=\"width: 100%; margin: 0; vertical-align: middle; position: absolute; top: 0; left: 0; box-shadow: inset 0px 0px 0px 400px white;\"\n        alt=\"export authentication hale\"\n        title=\"\"\n        src=\"/static/31e5047226ec835f4c5a432655eaca71-44d6a.png\"\n        srcset=\"/static/31e5047226ec835f4c5a432655eaca71-f4799.png 173w,\n/static/31e5047226ec835f4c5a432655eaca71-b3b1d.png 345w,\n/static/31e5047226ec835f4c5a432655eaca71-44d6a.png 690w,\n/static/31e5047226ec835f4c5a432655eaca71-bc0f7.png 1035w,\n/static/31e5047226ec835f4c5a432655eaca71-526b7.png 1048w\"\n        sizes=\"(max-width: 690px) 100vw, 690px\"\n      />\n    </span>\n  </span>\n  \n  </a>\n    </p>\n<p>Fill the values for the administration of <strong>GeoAvalanche</strong> server. By default they are set up to <code>admin/geoserver</code></p>\n<p>Then click <code>Finish</code> and wait for the completion of the upload. Once finished you can close <strong>Hale</strong> and play with the <strong>Region</strong> features</p>\n<p>Visit the <code>Layer Preview</code> page of GeoAvalanche and you should see a new layer in the list which is named <code>caaml:Region</code>:</p>\n<p></p>\n<p>We have just successfully created a new app-schema datastore in GeoAvalanche. Let's see now how we can query our regions.</p>",
			"timeToRead": 1,
			"excerpt": "Export the CAAML application schema configuration At the end of the mapping session we should have completed all the mapping properties for...",
			"frontmatter": {
				"title": "Push the configuration to GeoAvalanche",
				"cover": null,
				"date": null,
				"category": null,
				"tags": null
			}
		},
		"tableOfContents": {
			"chapters": [
				{
					"title": "1. Introduction",
					"entries": null,
					"chapters": [
						{
							"title": "1.1 OGC Standards",
							"entries": [
								{
									"entry": {
										"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/intro_ogc.md absPath of file",
										"childMarkdownRemark": {
											"fields": {
												"slug": "/introduction-to-ogc"
											},
											"frontmatter": {
												"title": "Introduction to OGC"
											}
										}
									}
								}
							],
							"chapters": [
								{
									"title": "1.1.1 Web Mapping Service",
									"entries": [
										{
											"entry": {
												"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/intro_wms.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/introduction-to-wms"
													},
													"frontmatter": {
														"title": "Introduction to WMS"
													}
												}
											}
										},
										{
											"entry": {
												"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/examples_wms.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/wms-examples"
													},
													"frontmatter": {
														"title": "WMS Examples"
													}
												}
											}
										}
									]
								},
								{
									"title": "1.1.2 Web Feature Service",
									"entries": [
										{
											"entry": {
												"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/intro_wfs.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/introduction-to-wfs"
													},
													"frontmatter": {
														"title": "Introduction to WFS"
													}
												}
											}
										},
										{
											"entry": {
												"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/examples_wfs.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/wfs-examples"
													},
													"frontmatter": {
														"title": "WFS Examples"
													}
												}
											}
										}
									]
								},
								{
									"title": "1.1.3 Web Coverage Service",
									"entries": [
										{
											"entry": {
												"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/intro_wcs.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/introduction-to-wcs"
													},
													"frontmatter": {
														"title": "Introduction to WCS"
													}
												}
											}
										},
										{
											"entry": {
												"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/examples_wcs.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/wcs-examples"
													},
													"frontmatter": {
														"title": "WCS Examples"
													}
												}
											}
										}
									]
								},
								{
									"title": "1.1.4 Web Processing Service",
									"entries": [
										{
											"entry": {
												"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/intro_wps.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/introduction-to-wps"
													},
													"frontmatter": {
														"title": "Introduction to WPS"
													}
												}
											}
										},
										{
											"entry": {
												"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/examples_wps.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/wps-examples"
													},
													"frontmatter": {
														"title": "WPS Examples"
													}
												}
											}
										}
									]
								}
							]
						},
						{
							"title": "1.2 CAAML",
							"entries": [
								{
									"entry": {
										"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/intro_caaml.md absPath of file",
										"childMarkdownRemark": {
											"fields": {
												"slug": "/introduction-to-caaml"
											},
											"frontmatter": {
												"title": "Introduction to CAAML"
											}
										}
									}
								}
							],
							"chapters": null
						},
						{
							"title": "1.3 INSPIRE",
							"entries": [
								{
									"entry": {
										"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/intro_inspire.md absPath of file",
										"childMarkdownRemark": {
											"fields": {
												"slug": "/introduction-to-inspire"
											},
											"frontmatter": {
												"title": "Introduction to INSPIRE"
											}
										}
									}
								}
							],
							"chapters": null
						}
					]
				},
				{
					"title": "2. Standards in action",
					"entries": null,
					"chapters": [
						{
							"title": "2.1 Prepare data and toolkit",
							"entries": [
								{
									"entry": {
										"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/intro_data_tools.md absPath of file",
										"childMarkdownRemark": {
											"fields": {
												"slug": "/data-and-geospatial-tools"
											},
											"frontmatter": {
												"title": "Data and geospatial tools"
											}
										}
									}
								},
								{
									"entry": {
										"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/bootstrap_servers.md absPath of file",
										"childMarkdownRemark": {
											"fields": {
												"slug": "/start-the-environment"
											},
											"frontmatter": {
												"title": "Start the environment"
											}
										}
									}
								}
							],
							"chapters": [
								{
									"title": "2.1.1 Manage the data",
									"entries": [
										{
											"entry": {
												"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/load_data.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/load-data"
													},
													"frontmatter": {
														"title": "Load Data"
													}
												}
											}
										},
										{
											"entry": {
												"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/clean_data.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/clean-data"
													},
													"frontmatter": {
														"title": "Clean Data"
													}
												}
											}
										}
									]
								},
								{
									"title": "2.1.2 Design the CAAML schema",
									"entries": [
										{
											"entry": {
												"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/er_design.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/caaml-model-design"
													},
													"frontmatter": {
														"title": "CAAML model design"
													}
												}
											}
										},
										{
											"entry": {
												"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/populate_data.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/populate-region"
													},
													"frontmatter": {
														"title": "Populate Region"
													}
												}
											}
										}
									]
								}
							]
						},
						{
							"title": "2.2 Build CAAML with GeoAvalanche",
							"entries": [
								{
									"entry": {
										"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/caaml_hale.md absPath of file",
										"childMarkdownRemark": {
											"fields": {
												"slug": "/configure-the-application-schema-for-caaml"
											},
											"frontmatter": {
												"title": "Configure the application schema for CAAML"
											}
										}
									}
								},
								{
									"entry": {
										"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/load_configuration.md absPath of file",
										"childMarkdownRemark": {
											"fields": {
												"slug": "/push-the-configuration-to-geo-avalanche"
											},
											"frontmatter": {
												"title": "Push the configuration to GeoAvalanche"
											}
										}
									}
								},
								{
									"entry": {
										"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/query_data.md absPath of file",
										"childMarkdownRemark": {
											"fields": {
												"slug": "/query-our-region-features"
											},
											"frontmatter": {
												"title": "Query our Region features"
											}
										}
									}
								}
							],
							"chapters": null
						}
					]
				},
				{
					"title": "3. Main Chapter",
					"entries": [
						{
							"entry": {
								"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/lesson_six.md absPath of file",
								"childMarkdownRemark": {
									"fields": {
										"slug": "/lesson-six"
									},
									"frontmatter": {
										"title": "Lesson Six"
									}
								}
							}
						}
					],
					"chapters": null
				}
			]
		}
	},
	"pathContext": {
		"slug": "/push-the-configuration-to-geo-avalanche"
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/push-the-configuration-to-geo-avalanche.json
// module id = 423
// module chunks = 113291268836709